import React, { useState } from "react";
import { GiCancel } from "react-icons/gi";
import { FiSave } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({ expr, handleCancelClick, increment, counter, setExprId }) => {
  const [newExpr, setNewExpr] = useState(expr);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewExpr((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "workexperience/" + newExpr.id + "/",
          newExpr,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setExprId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    if (new Date(newExpr.start_date) > new Date(newExpr.end_date)) {
      alert("לא ניתן לעדכן את את הרשומה,תאריך סיום הקורס קטן מתאריך ההתחלה");
    } else {
      updateData();
    }
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          name="address"
          className="form-control"
          id="address"
          value={newExpr.address}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="date"
          name="start_date"
          className="form-control"
          id="start_date"
          value={newExpr.start_date}
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="date"
          name="end_date"
          className="form-control"
          id="end_date"
          value={newExpr.end_date}
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="job"
          className="form-control"
          id="job"
          value={newExpr.job}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="last_salary"
          className="form-control"
          id="last_salary"
          value={newExpr.last_salary}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="end_reason"
          className="form-control"
          id="end_reason"
          value={newExpr.end_reason}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          <FiSave />
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          <GiCancel />
        </button>
      </td>
    </tr>
  );
};

export default Edit;
